import React from 'react';
import { StoreMap, stores } from '../components/map/StoreMap';
import { KPICard } from '../components/ui/KPICard';
import { Star, MessageSquare, Store } from 'lucide-react';
export function HeatmapPage() {
  return <div className="flex flex-col h-[calc(100vh-64px)]" data-id="element-617">
      {/* KPI Overlay / Header Area */}
      <div className="px-6 py-6 bg-edeka-light z-10" data-id="element-618">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-619">
          <KPICard title="Anzahl Autohäuser" value={stores.length.toString()} icon={<Store size={18} data-id="element-621" />} data-id="element-620" />
          <KPICard title="Ø Bewertungs-Score" value="4,2" icon={<Star size={18} data-id="element-623" />} data-id="element-622" />
          <KPICard title="Bewertungen gesamt" value="12.482" icon={<MessageSquare size={18} data-id="element-625" />} data-id="element-624" />
        </div>
      </div>

      {/* Map Area */}
      <div className="flex-1 relative border-t border-gray-200" data-id="element-626">
        <StoreMap data-id="element-627" />
      </div>
    </div>;
}